import React from 'react';
import logoImage from '../assets/logo.jpg';
const ChiSiamo = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary to-primary/80 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">Chi Siamo</h1>
          <p className="text-xl text-center max-w-3xl mx-auto">
            L'<strong>Associazione Robin Hood Roma ODV</strong> è un'organizzazione di volontariato costituita da genitori e da pazienti con malattie ematologiche rare, 
            seguiti presso l'Ematologia, AOU Policlinico Umberto I, Sapienza Università di Roma.
          </p>{/* 
          <p className="text-xl text-center max-w-3xl mx-auto mt-4">
            L'utilità sociale e la solidarietà sono la base sui quali si è costituita l'Associazione, il cui scopo è garantire a tutti i malati 
            ‒ bambini, adolescenti e adulti ‒ di poter usufruire dell'assistenza di cui hanno bisogno.
          </p>
          <p className="text-xl text-center max-w-3xl mx-auto mt-4">
            L'idea "che nessun paziente abbia di meno" anima lo spirito dei volontari, dei soci e di tutti coloro che operano in questa Associazione.
          </p> */}
        </div>
      </div>

      {/* Mission Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0 md:pr-10">
              <img 
                src={logoImage} 
                alt="La nostra missione" 
                className="rounded-lg shadow-xl w-full"
              />
            </div>
            <div className="md:w-1/2">
              <h2 className="text-3xl font-bold text-primary mb-6">La Nostra Mission</h2>
              <p className="text-gray-700 mb-4">
                L'Associazione sostiene i pazienti con patologie rare ematologiche; agisce a stretto contatto con gli infermieri, 
                i medici e gli specialisti; collabora con le altre associazioni che operano nella stessa struttura. In particolare:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-700">
                <li className="mb-2">Supporta economicamente i pazienti in difficoltà economiche per garantire le loro necessità diagnostiche e/o terapeutiche, in base al principio che nessuno abbia di meno;</li>
                <li className="mb-2">Favorisce e promuove attività di supporto ricreativo e terapie di sostegno mirate al benessere dei pazienti e dei loro familiari, nonché degli operatori della struttura;</li>
                <li className="mb-2">Facilita l'accesso ai servizi sulle malattie rare che operano in Ematologia, con un sito internet fruibile ed aggiornato, strutturato anche per favorire e promuovere la diffusione della conoscenza di queste patologie;</li>
                <li className="mb-2">Stimola e promuove i rapporti tra il personale medico, infermieristico, le famiglie e gli altri operatori del settore;</li>
                <li className="mb-2">Favorisce la ricerca nel campo delle malattie ematologiche rare:
                  <ul className="list-disc pl-6 mt-2">
                    <li className="mb-2">Promuovendo studi e ricerche sulle patologie rare di interesse ematologico;</li>
                    <li className="mb-2">Continuando a supportare infermieri, medici per convegni e/o riunioni e/o corsi di aggiornamento e di formazione sulle patologie di cui sono affetti i pazienti seguiti;</li>
                    <li className="mb-2">Finanziando premi di laurea e di specializzazione su argomenti riguardanti le malattie rare ematologiche o di interesse ematologico, destinato a studenti e specializzandi dell'Ematologia, Università Sapienza di Roma;</li>
                  </ul>
                </li>
                <li className="mb-2">Incoraggia i rapporti di collaborazione tra centri nazionali e internazionali, nonché organizzazioni ed enti che perseguono scopi analoghi.</li>
              </ul>
              <p className="text-gray-700">
                Le richieste da parte dei pazienti, dei familiari e degli operatori vengono valutate e discusse dal Consiglio Direttivo, 
                coadiuvato anche dal Comitato Scientifico. Il Consiglio Direttivo si impegna a realizzarle, reperendo fondi seguendo le 
                modalità previste dallo Statuto dell'Associazione.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* History Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-primary mb-12">La Nostra Storia</h2>
          <div className="max-w-4xl mx-auto">
            <div className="border-l-4 border-primary pl-8 mb-12 relative">
              <div className="absolute w-4 h-4 bg-primary rounded-full -left-[10px] top-2"></div>
              <h3 className="text-2xl font-semibold text-accent mb-3">2004 - La fondazione</h3>
              <p className="text-gray-700 mb-4">
                <strong>Associazione Robin Hood Roma Onlus</strong> nasce l'8 luglio 2004, per volontà di genitori dei bambini e degli adolescenti, 
                seguiti presso l'Ematologia Pediatrica dell'Ematologia, AOU Policlinico Umberto I, Sapienza Università di Roma, 
                in linea con le direttive dell'AIEOP (Associazione Italiana di Ematologia e Oncologia Pediatrica).
              </p>
              <p className="text-gray-700 mb-4">
                Dalla sua fondazione fino all'ottobre 2022, l'Associazione ha potuto svolgere la propria mission grazie al generoso 
                supporto di genitori, pazienti e amici: ha aiutato economicamente famiglie di pazienti in difficoltà; ha acquistato 
                presidi medicali indispensabili per il buon funzionamento dell'assistenza per i bambini; ha acquistato letti per i 
                genitori dei piccoli pazienti ricoverati; ha supportato il personale medico e infermieristico nei corsi di formazione 
                e di aggiornamento; ha finanziato una psicologa per l'attività clinica; ha sostenuto le attività delle nove edizioni 
                del «Master in Ematologia Pediatrica» istituito dalla Sapienza Università di Roma; e ha curato la stampa annuale di 
                un calendario con disegni realizzati dai pazienti pediatrici.
              </p>
            </div>
            
            <div className="border-l-4 border-primary pl-8 mb-12 relative">
              <div className="absolute w-4 h-4 bg-primary rounded-full -left-[10px] top-2"></div>
              <h3 className="text-2xl font-semibold text-accent mb-3">2022 - La trasformazione</h3>
              <p className="text-gray-700 mb-4">
                Nell'ottobre 2022, con la chiusura del reparto pediatrico e le dimissioni irrevocabili dello storico presidente, 
                Aldo Spinella, è stato deciso di proseguire l'attività dell'Associazione focalizzando l'attenzione nel supportare 
                i pazienti con patologie rare ematologiche di qualsiasi età (bambini, adolescenti e adulti) affetti da malattie 
                rare ematologiche.
              </p>
              <p className="text-gray-700 mb-4">
                Trasmigrata nel RUNTS (Registro Unico Nazionale Terzo Settore) nel novembre 2022, l'«Associazione Robin Hood Roma Onlus» 
                è diventata, nel marzo 2024, una ODV, con un nuovo statuto ed ha acquisito personalità giuridica.
              </p>
            </div>
            
            <div className="border-l-4 border-primary pl-8 relative">
              <div className="absolute w-4 h-4 bg-primary rounded-full -left-[10px] top-2"></div>
              <h3 className="text-2xl font-semibold text-accent mb-3">Oggi</h3>
              <p className="text-gray-700">
                Dal 2022 a oggi, l'Associazione ha continuato a sostenere economicamente e a migliorare l'assistenza ai pazienti 
                con malattie rare seguiti in Ematologia: con l'acquisto di dispositivi medici (come elettrocardiografi, reagenti, etc); 
                a supportare medici e infermieri per migliorare la loro professionalità in ambiti specifici (trapianto di cellule 
                staminali e terapie innovative, etc).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Unisciti alla Nostra Causa</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Ogni giorno lavoriamo per migliorare la vita delle persone affette da malattie ematologiche rare. Con il tuo supporto, possiamo fare ancora di più.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="/sostienici" 
              className="inline-block bg-white text-primary hover:bg-gray-100 font-medium py-3 px-6 rounded-lg transition-colors"
            >
              Fai una Donazione
            </a>
            <a 
              href="/contatti" 
              className="inline-block bg-accent text-white border border-white hover:bg-accent/90 font-medium py-3 px-6 rounded-lg transition-colors"
            >
              Contattaci
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChiSiamo;
